import React from 'react'
import PropTypes from 'prop-types'
import * as insertExitBlock from '../../slateUtils/insertExitBlock'
import InsertEmptySpaceButton from './InsertEmptySpaceButton'

class InsertEmptySpaceButtonContainer extends React.PureComponent {
  constructor (props, context) {
    super(props, context)
    this.state = {}
  }

  componentDidMount () {
  }

  onInsert = (event, after) => {
    const {state, block, onChange} = this.props
    let transform = insertExitBlock({state, transform: state.transform(), block, after})
    event.preventDefault()
    return onChange(transform.apply())
  }

  onInsertBefore = event => {
    this.onInsert(event, false)
  }

  onInsertAfter = event => {
    this.onInsert(event, true)
  }

  render () {
    const { block, state } = this.props
    const hasContentBefore = state.document.getPreviousSibling(block.key)
    const hasContentAfter = state.document.getNextSibling(block.key)
    const hasBlockAfter = hasContentAfter && hasContentAfter.kind === 'block' && hasContentAfter.type !== 'paragraph'
    const hasBlockBefore = hasContentBefore && hasContentBefore.kind === 'block' && hasContentBefore.type !== 'paragraph'
    let canInsertSpaceBefore = hasContentBefore ? hasBlockBefore : true
    let canInsertSpaceAfter = hasContentAfter ? hasBlockAfter : true
    const extra = {
      onInsertBefore: this.onInsertBefore,
      onInsertAfter: this.onInsertAfter,
      canInsertSpaceBefore,
      canInsertSpaceAfter
    }
    return <InsertEmptySpaceButton {...this.props} {...this.state} {...extra} />
  }
}

InsertEmptySpaceButtonContainer.propTypes = {
  block: PropTypes.object,
  state: PropTypes.object,
  onChange: PropTypes.func
}

export default InsertEmptySpaceButtonContainer



// WEBPACK FOOTER //
// ./src/components/InsertEmptySpaceButton/InsertEmptySpaceButtonContainer.js